import { StyleSheet } from 'react-native';

type Colors = {
  background: string;
  text: string;
  textSecondary: string;
  primary: string;
  primaryText: string;
  border: string;
  surface: string;
};

export const createStyles = (colors: Colors) =>
  StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: colors.background,
    },
    // paddingTop/paddingBottom come from useSafeAreaInsets applied inline on container
    inner: {
      flex: 1,
      paddingHorizontal: 24,
    },

    // ── Header ──
    header: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingTop: 12,
      paddingBottom: 8,
    },
    headerLogo: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 8,
    },
    logoIcon: {
      width: 28,
      height: 28,
    },
    logoText: {
      fontSize: 20,
      fontWeight: '800',
      color: colors.primary,
      letterSpacing: -0.3,
    },
    signInLink: {
      fontSize: 15,
      fontWeight: '600',
      color: colors.primary,
    },

    // ── Hero image ──
    // flex: 1 absorbs all space between header and content
    heroContainer: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      marginVertical: 12,
    },
    imageFrame: {
      width: '80%',
      flex: 1,
      borderRadius: 20,
      overflow: 'hidden',
      borderWidth: 1.5,
      borderColor: colors.border,
      shadowColor: '#000',
      shadowOffset: { width: 0, height: 6 },
      shadowOpacity: 0.18,
      shadowRadius: 14,
      elevation: 10,
    },
    heroImage: {
      width: '100%',
      height: '100%',
    },

    // ── Content ──
    content: {
      paddingTop: 4,
    },
    headline: {
      fontSize: 28,
      fontWeight: '800',
      color: colors.text,
      letterSpacing: -0.5,
      lineHeight: 34,
      marginBottom: 16,
    },

    // ── Features ──
    features: {
      gap: 10,
      marginBottom: 24,
    },
    featureRow: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 10,
    },
    featureIconWrap: {
      width: 28,
      height: 28,
      borderRadius: 8,
      alignItems: 'center',
      justifyContent: 'center',
    },
    featureText: {
      fontSize: 14,
      color: colors.textSecondary,
      flex: 1,
    },

    // ── CTAs ──
    primaryBtn: {
      backgroundColor: colors.primary,
      borderRadius: 14,
      paddingVertical: 15,
      alignItems: 'center',
      marginBottom: 14,
    },
    primaryBtnText: {
      fontSize: 16,
      fontWeight: '700',
      color: colors.primaryText,
      letterSpacing: 0.2,
    },
    secondaryRow: {
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      gap: 6,
    },
    secondaryText: {
      fontSize: 14,
      color: colors.textSecondary,
    },
    signInBtn: {
      fontSize: 14,
      fontWeight: '700',
      color: colors.primary,
    },
  });
